import React, { useState, useEffect } from "react";
import InventoryForm from "./InventoryForm";
import { Column, Row } from "simple-flexbox";
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
} from "@material-ui/core";
import useTable from "../../../utilities/useTable";
import { ToastContainer } from "react-toastify";
import StatComponent from "../../stat-page/StatComponent";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import Controls from "../../../controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import Popup from "../../../utilities/Popup";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CloseIcon from "@material-ui/icons/Close";
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";
import AddInventoryForm from "./AddInventoryForm";
import AddInventoryCount from "./AddInventoryCount";
import InventoryCorrection from "./InventoryCorrection";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    // margin: theme.spacing(1),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "75%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
}));

const headCells = [
  { id: "locationName", label: "LOCATION NAME" },
  { id: "storageTankId", label: "STORAGE TANK" },
  { id: "quanity", label: "IN-STOCK" },
  { id: "productName", label: "PRODUCT NAME" },
  { id: "costPrice", label: "COST PRICE" },
  { id: "totalItemValue", label: "TOTAL ITEM VALUE" },
  { id: "actions", label: "Actions", disableSorting: true },
];

export function Inventory({
  locations,
  storageTanks,
  AddInventory,
  LoadInventories,
  LoadStorageTanks,
  inventories,
  products,
  roles,
  AddInventoryCorrection,
}) {
  function VerifyRole() {
    var role = roles;
    if (
      role[0] == "Inventory Manager" ||
      role[0] == "App Owner" ||
      role[0] == "Sales Representative"
    ) {
      return true;
    }
  }

  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [addOpenPopup, setAddOpenPopup] = useState(false);
  const [correctionOpenPopup, setCorrectionOpenPopup] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(inventories, headCells, filterFn);

  useEffect(() => {
    LoadInventories(roles);
    LoadStorageTanks(roles);
    return () => {};
  }, []);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) =>
            x.locationName.toLowerCase().includes(target.value)
          );
      },
    });
  };

  const addOrEdit = (inventory, resetForm) => {
    if (inventory.id === 0) AddInventory(inventory);
    else var data = { ...inventory };
    AddInventory(data);
    resetForm();
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  const addCorrection = (inventory, resetForm) => {
    AddInventoryCorrection(inventory);
    setCorrectionOpenPopup(false);
  };

  const addInventory = (inventory, resetForm) => {
    AddInventory(inventory);
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit(item);
    setOpenPopup(true);
  };

  const onDelete = (id) => {
    //   DeleteLocation(id)
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };
  return (
    <>
      <div>
        <div>
          <Column>
            <ToastContainer />
            <div className="mr-2 mb-3">
              <Controls.Input
                placeholder="Search Inventories by Location Name"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
                onChange={handleSearch}
                watcherGetInventoryCountSaga
              />
            </div>

            <Paper className={classes.pageContent}>
              <h4>
                {" "}
                <strong>Inventory</strong>
              </h4>
              <div
                className="container row p-0 m-0"
                style={{ width: "35rem", position: "relative", left: "23rem" }}
              >
                <div className="col">
                  <Toolbar>
                    {VerifyRole() ? (
                      <Controls.Button
                        text="Add Item to Inventory"
                        variant="outlined"
                        startIcon={<AddIcon />}
                        className={classes.newButton}
                        onClick={() => {
                          setAddOpenPopup(true);
                          setRecordForEdit(null);
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </Toolbar>
                </div>
                <div className="col">
                  {VerifyRole() ? (
                    <Toolbar>
                      <Controls.Button
                        text="Inventory Correction"
                        variant="outlined"
                        startIcon={<AddIcon />}
                        className={classes.newButton}
                        onClick={() => {
                          setCorrectionOpenPopup(true);
                          setRecordForEdit(null);
                        }}
                      />
                    </Toolbar>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <TblContainer>
                <TblHead />
                <TableBody>
                  {recordsAfterPagingAndSorting().map((item) => (
                    <TableRow key={item.dateCreated}>
                      <TableCell>{item.locationName}</TableCell>
                      <TableCell>{item.storageTankId}</TableCell>
                      <TableCell>{item.quantity}</TableCell>
                      <TableCell>{item.productName}</TableCell>
                      <TableCell>{item.costPrice}</TableCell>
                      <TableCell>{item.totalItemValue}</TableCell>
                      <TableCell>
                        <Controls.ActionButton
                          color="primary"
                          onClick={() => {
                            openInPopup(item);
                          }}
                        >
                          <EditOutlinedIcon fontSize="small" />
                        </Controls.ActionButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </Paper>
            <Popup
              title="Inventory Form"
              openPopup={openPopup}
              setOpenPopup={setOpenPopup}
            >
              <InventoryForm
                recordForEdit={recordForEdit}
                addOrEdit={addOrEdit}
                locations={locations}
                products={products}
              />
            </Popup>

            <Popup
              title="Add Inventory Form"
              openPopup={addOpenPopup}
              setOpenPopup={setAddOpenPopup}
            >
              <AddInventoryForm
                recordForEdit={recordForEdit}
                addOrEdit={addOrEdit}
                locations={locations}
                storageTanks={storageTanks}
                products={products}
              />
            </Popup>

            <Popup
              title="Inventory Correction Form"
              openPopup={correctionOpenPopup}
              setOpenPopup={setCorrectionOpenPopup}
            >
              <InventoryCorrection
                recordForEdit={recordForEdit}
                addCorrection={addCorrection}
                setOpenPopup={setOpenPopup}
                locations={locations}
                products={products}
              />
            </Popup>

            <Notification notify={notify} setNotify={setNotify} />
            <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
          </Column>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    locations: state.locationReducer.locationDrop,
    storageTanks: state.storageTanksReducer.storageTanks,
    products: state.productReducer.productList,
    roles: state.persistReducer.roles,
    inventories: state.inventoryReducer.inventories,
  };
}
const mapDispatchToProps = (dispatch) => ({
  LoadInventories(payload) {
    dispatch({ type: "LOAD_INVENTORIES", payload });
  },
  LoadStorageTanks(payload) {
    dispatch({ type: "LOAD_STORAGE_TANKS", payload });
  },
  AddInventory(payload) {
    dispatch({ type: "ADD_INVENTORY", payload });
  },

  AddInventoryCorrection(payload) {
    dispatch({ type: "ADD_INVENTORY_CORRECTION", payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Inventory);
